// Title: auto-sale.js
// Created by: Reid Williams
// Last Modified by: Reid Williams
// Last Modified: Oct 11, 2024
// Description: This script calculates and formats the sale price of a product based on the original price and sale percentage.
//              It updates the displayed price in the Recharge widget.

function formatMoney(cents, format = "") {
  // Convert cents to a string if necessary
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || window.themeVariables.settings.moneyFormat;

  function defaultTo(value, defaultValue) {
    // Ensure value is not null or NaN
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    // Set default values for formatting
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    // Convert to cents, round up, then format
    number = Math.ceil(number) / 100;
    number = number.toFixed(precision);

    let parts = number.split("."),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

//----------------
//UPDATE SALE PRICE - CUSTOM PRICE
//----------------
function updateSalePrice() {
  // --- Get Sale Amount and Variant Price ---
  // const productMeta = document.getElementById('ProductMeta');
  // let saleAmount = parseInt(productMeta.getAttribute('data-sale-amount'), 10) || 0;

  // If saleAmount is 0, do not change prices
  if (saleAmount === 0) {
    //console.log("Sale amount is 0, prices will not be changed.");
    return; // Exit the function early
  }

  const variantPriceElement = document.getElementById('VariantPrice-Sale');
  const variantPriceText = variantPriceElement.getAttribute('data-variant-price');
  const variantPrice = parseFloat(variantPriceText.replace(/[^0-9.-]+/g, "")) || 0;

  // Calculate the discount amount and updated price
  const discountAmount = (variantPrice * (saleAmount / 100));
  const updatedPrice = variantPrice - discountAmount; 
  const formattedUpdatedPrice = formatMoney(updatedPrice * 100); 

  const formattedOriginalPrice2 = formatMoney(variantPrice * 100); 

  // Calculate the stacked discount as a percentage of the original price
  const discountStacked = (updatedPrice * (15 / 100));
  const updatedPriceSub = updatedPrice - discountStacked; // Subtract the discount from the original price
  const formattedUpdatedPriceSub = formatMoney(updatedPriceSub * 100);
  
  // Use MutationObserver to update prices in the Recharge widget
  const observer = new MutationObserver(function(mutations, observerInstance) {
    const rechargePriceElement = document.querySelector('.rc-radio__price');
    if (rechargePriceElement) {
      //rechargePriceElement.textContent = ' ' + formattedUpdatedPrice;

      rechargePriceElement.innerHTML = ` ${variantPrice} <span style="text-decoration: line-through; margin-left: 8px; font-size: 17px; color: #010203;">${formattedOriginalPrice2}</span>
      <span style="background-color: transparent; color: #FA1818; display: inline-block; padding: 4px 8px; margin-left: 8px;border: 1px solid rgb(var(--border-color));">

            ${saleAmount}% OFF
          </span>`;
     /*
      rechargePriceElement.innerHTML = rechargePriceElement.innerHTML + `<span style="text-decoration: line-through; margin-left: 8px; font-size: 17px; color: gray;">${formattedOriginalPrice2}</span>`;
      */
      
      const oneTimePurchaseLabel = document.querySelector('label.rc-radio.onetime-radio .rc-radio__label');  
      if (oneTimePurchaseLabel) {
        //oneTimePurchaseLabel.textContent = 'One-Time Purchase ' + formattedUpdatedPrice;
        oneTimePurchaseLabel.innerHTML = `One-Time Purchase — ${formattedUpdatedPrice} <span style="text-decoration: line-through; margin-left: 8px; font-size: 16px; color: #7F8080;">${formattedOriginalPrice2}</span>  
        <span class="pdp-widget__discount" style="background-color: transparent; color: #FA1818; display: inline-block; padding: 4px 8px; margin-left: 8px;border: 1px solid rgb(var(--border-color));">
      ${saleAmount}% OFF
    </span>`;
    /*
        if (oneTimePurchaseLabel.innerHTML.indexOf('—') < 0) {
          oneTimePurchaseLabel.innerHTML = oneTimePurchaseLabel.innerHTML.replace('One-Time Purchase', 'One-Time Purchase — ');
        }
    */
      }
      
      observerInstance.disconnect(); // Stop observing once the elements are found and updated
    }
  });

  // Start observing the body for any added nodes
  observer.observe(document.body, { childList: true, subtree: true });


  


}


//----------------
//RECHARGE PRICE MOD
//----------------
function modRecharge() {
  const variantPriceElement = document.getElementById('VariantPrice-Sale');

  const variantPriceText = variantPriceElement.getAttribute('data-variant-price');
  const variantPrice = parseFloat(variantPriceText.replace(/[^0-9.-]+/g, "")) || 0;

  const compareAtPriceText = variantPriceElement.getAttribute('data-compare-at-price');
  const compareAtPrice = parseFloat(compareAtPriceText.replace(/[^0-9.-]+/g, "")) || 0;

  const formattedPrice = formatMoney(variantPrice * 100);
  const formattedCompareAtPrice = formatMoney(compareAtPrice * 100);

  const rechargePrice = variantPrice * 0.85;
  const formattedRechargePrice = formatMoney(rechargePrice * 100);

  // Observer for the dropdown (Wait for it to exist)
  const observerDropdown = new MutationObserver((mutations, observerInstance) => {
    let dropdown = document.querySelector('.rc-selling-plans-dropdown__select');

    if (dropdown) {
      //console.log("Dropdown found, updating selection...");

      let indexMap = {
        "10ml": 0,
        "60ml": 1,
        "120ml": 2,
        "500ml": 3,
        "Half Gallon": 2
      };

      if (variantTitle in indexMap) {
        dropdown.selectedIndex = indexMap[variantTitle];
        let event = new Event('change', { bubbles: true });
        dropdown.dispatchEvent(event);
        //console.log(`Dropdown updated to ${variantTitle}`);
      }

      observerInstance.disconnect(); // Stop observing after successful update
    }
  });

  observerDropdown.observe(document.body, { childList: true, subtree: true });

  // If saleAmount is 0, do not change prices
  if (saleAmount === 0) {
    //console.log("Sale amount is 0, only updating recharge price...");

    // Observer for .rc-radio__price (Wait for it to exist)
    const observerNormalSub = new MutationObserver((mutations, observerInstance) => {
      const rechargePriceElement2 = document.querySelector('.rc-radio__price');

      if (rechargePriceElement2) {
        rechargePriceElement2.innerHTML = ` ${formattedRechargePrice} 
          <span style="background-color: transparent; display: inline-block; margin-left: 8px;">
            <span style="padding:4px 8px;border: 1px solid rgb(var(--border-color));color: #FA1818;">SAVE 15%*</span>
          </span>`;

        //console.log("Updated recharge price successfully.");
        observerInstance.disconnect(); // Stop observing after successful update
      }
    });

    observerNormalSub.observe(document.body, { childList: true, subtree: true });

    return; // Exit the function early
  }
  
  // Use MutationObserver to update prices in the Recharge widget
  const observer = new MutationObserver(function(mutations, observerInstance) {
    const rechargePriceElement = document.querySelector('.rc-radio__price');
    if (rechargePriceElement) {
      rechargePriceElement.innerHTML = ` ${formattedPrice} <span style="text-decoration: line-through; margin-left: 8px; font-size: 17px; color: #010203;">${formattedCompareAtPrice}</span>
      <span style="background-color: transparent; display: inline-block; margin-left: 8px;">
            <span style="padding: 4px 8px;border: 1px solid rgb(var(--border-color));color: #FA1818;">20% OFF</span>
          </span>`;
      
      const oneTimePurchaseLabel = document.querySelector('label.rc-radio.onetime-radio .rc-radio__label');  
      if (oneTimePurchaseLabel) {
        oneTimePurchaseLabel.innerHTML = `One-Time Purchase ${formattedPrice} <span style="text-decoration: line-through; margin-left: 8px; font-size: 17px; color: #010203;">${formattedCompareAtPrice}</span>  
        <span style="background-color: transparent; color: #FA1818; display: inline-block; padding: 4px 8px; margin-left: 8px;border: 1px solid rgb(var(--border-color));">
      20% OFF
    </span>`;
      }
      observerInstance.disconnect(); // Stop observing once the elements are found and updated
    }
  });

  // Start observing the body for any added nodes
  observer.observe(document.body, { childList: true, subtree: true });
}

const productMeta = document.getElementById('ProductMeta');
let saleAmount = parseInt(productMeta.getAttribute('data-sale-amount'), 10) || 0;

const salePriceDiv = document.querySelector('.price-list.price-list--product');
const originalPriceDiv = document.getElementById('original-price');

const variantTitleData = document.getElementById('VariantTitleData');
let variantTitle = variantTitleData.getAttribute('data-variant-title');
//console.log(variantTitle);

//document.addEventListener('DOMContentLoaded', updateSalePrice);
document.addEventListener('DOMContentLoaded', modRecharge);



